import { rem } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMemo } from 'react';
export const MIN_WEB_TOOLBAR_HEIGHT = rem(282);
export const useKeyboardHeightWeb = () => {
    const { height } = useAppFrameDimensions(true);
    return useMemo(() => Math.max(height * 0.45, MIN_WEB_TOOLBAR_HEIGHT), [height]);
};
